import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import useAuthorizationData from "../../../utils/useAuthorizationData";
import { Menu, Dropdown } from "antd";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";

const LogoutButton = () => {
  const history = useHistory();
  const [authorizationData, setAuthorizationData] = useAuthorizationData();

  const logoutClicked = () => {
    setAuthorizationData.reset();
    history.push("/login");
  };

  const menu = (
    <Menu>
      <Menu.Item icon={<UserOutlined />}>
        {authorizationData != null && authorizationData.login != null
          ? authorizationData.login
          : "User"}
      </Menu.Item>
      <Menu.Item>
        <Button type="link" onClick={logoutClicked}>
          Logout
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {authorizationData != null && authorizationData.login != null ? (
        <Dropdown className="header-link" overlay={menu}>
          <MenuOutlined />
        </Dropdown>
      ) : null}
    </>
  );
};

LogoutButton.displayName = "LogoutButton";

export default LogoutButton;
